module.exports = __webpack_public_path__ + "img/scholar7.29c26c1c.png";